import types from "actions/office_view/types";
import callTypes from "actions/call/types";
import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";
import { PhoneUtil } from "utils";

const newCall = (state, leg, call) => {
    call.status = "ringing";
    call.display = true;
    if (state.calls[call.uuid]) {
        if (call.company_destination && state.calls[call.uuid].start) {
            call.start = state.calls[call.uuid].start;
        } else {
            call.drift = state.calls[call.uuid].drift;
        }
    } else if (call.start) {
        call.drift = call.start - Math.floor(Date.now() / 1000)
    } else {
        call.start = Math.floor(Date.now() / 1000);
        call.drift = 0;
    }

    call.actionButtons = {
        hangup: false,
        vmDrop: false,
        transfer: false,
        hold: false,
        mute: false,
        answer: false,
    };
    
    const myleg = state.creds.extension && call.legs.find(l => (l.extension === state.creds.extension && (!call.ringing_agent || l.channel_uuid)))
    if (myleg) {
        if (!state.currentCall || call.direction === 'outbound' || call.direction === 'internal') {
            const leg = call.legs.find(l => l.extension !== state.creds.extension);
            state.currentCall = call.uuid
            state.callState = call.status
            if(call.call_type !== "click2dial"){
                state.contact_lookup = leg
            }
            state.currentCallPhoneNumber = leg?.phone
        }
    }

    //TODO: Potential for threeway, or warm transers else do bottom code block, lines 49-60
    //if (call.call_type === 'threeway' || call.call_type === 'warm') { set = false}
    if (call.direction === 'outbound') {
        const userLeg = call.legs.find(l => l.extension);
        if (userLeg) {
            if (state.extensions[userLeg?.extension]) {
                //if call extension exists
                if (! state.extensions[userLeg?.extension].find(c => c === call.uuid)) {
                    state.extensions[userLeg.extension].push(call.uuid)
                }
            } else {
                //if extension does not exist
                state.extensions[userLeg.extension] = [call.uuid];
            }
        }
    } else if (call.direction === 'internal') {
        call.legs.forEach((leg) => {
            if(leg?.extension){
                if (!call.ringing_agent || leg.channel_uuid) {
                    const uniqueExtension = state.extensions[leg.extension]?.find((extUUID) => extUUID === call.uuid);
                    if(!!!uniqueExtension){
                        if(state.extensions[leg.extension]){
                            //if call extension exists
                            state.extensions[leg.extension].push(call.uuid)
                        } else {
                            //if extension does not exist
                            state.extensions[leg.extension] = [call.uuid];
                        }
                    }
                }
            } 
        })
    } else {
        const eventLeg = call.legs.find(l => l.channel_uuid === leg);
        if(eventLeg?.extension){
            if (state.extensions[eventLeg.extension]) {
                //if call extension exists
                state.extensions[eventLeg.extension].push(call.uuid)
            } else {
                //if extension does not exist
                state.extensions[eventLeg.extension] = [call.uuid];
            }
        }
    }
    state.calls[call.uuid] = call
    return { ...state, extensions: { ...state.extensions }, calls: { ...state.calls }} ;
}

const connectedCall = (state, leg, call) => {
    call.status = "active";
    if (state.calls[call.uuid]) {
        //if WS is avalible update
        state.calls[call.uuid].connected = call.connected;
        state.calls[call.uuid].status = "active";
    } else if (state.calls['_' + call.sip_call_id]) {
        //if WEBRTC is avalible update
        state.calls[call.uuid] = call;
        delete state.calls['_' + call.sip_call_id]
        if (state.currentCall === '_' + call.sip_call_id) {
            state.currentCall = call.uuid;
        }
        const idx = state.extensions[state.creds.extension].indexOf('_' + call.sip_call_id)
        if (idx !== -1) {
            state.extensions[state.creds.extension][idx] = call.uuid
        }
    } else {
        //set WS message
        state.calls[call.uuid] = call;
    }

    if (state.calls[call.uuid]?.company_destination) {
        if (state.extensions[state.calls[call.uuid].company_destination]) {
            state.extensions[state.calls[call.uuid].company_destination] = state.extensions[state.calls[call.uuid].company_destination]?.filter(c => c !== call.uuid)
        }
        delete state.calls[call.uuid].company_destination
    }
    
    state.calls[call.uuid].drift = call.connected - Math.floor(Date.now() / 1000);
    if (call.uuid === state?.currentCall?.uuid) {
        state.status = 'active';
    }
    if (call.direction !== 'internal' && call.legs.find(l => l.extension === state.creds.extension) && call?.connected) {
        const phone = PhoneUtil.removeCountryCode(call.legs.find(l => !l.user_id).phone)
        if (phone) {
            state.creds.launch_url.forEach((url, index) => {
                const popurl = url.url.replace(/%%phone(_number)?%%/i, phone)
                setTimeout(() => window.open(popurl, '_blank', 'noopener,noreferrer'), index * 300);
            })
        }
    }
    return state;
};

const endCall = (state, legUUID, call) => {
    const leg = call.legs.find(l => l.channel_uuid === legUUID);
    if(call.uuid === legUUID) {
        state.extensions[call.company_destination] = state.extensions[call.company_destination]?.filter(c => c !== call.uuid)
    } 
    if(leg.extension === state.creds.extension && state.currentCall === call.uuid) {
        const curLeg = state.calls[call.uuid]?.legs.find(l => l.extension === leg.extension)
        if (curLeg && curLeg.channel_uuid !== legUUID) {
            return state
        }
        state.calls[call.uuid].duration = call.duration || 0;
        state.extensions[leg.extension] = state.extensions[leg.extension]?.filter(c => c !== call.uuid)
        state.currentCall = null
        if (call.connected) {
            state.endedCalls[leg.extension] = { ...call };
            state.callState = 'hangup'
        } else {
            state.callState = 'idle'
            state.islookingupContact = false
            state.contact_lookup = null
        }
    } else if(leg?.extension) {
        state.extensions[leg.extension] = state.extensions[leg.extension]?.filter(c => c !== call.uuid)
    }
    return { ...state, endedCalls: { ...state.endedCalls}, extensions: { ...state.extensions }, calls: { ...state.calls }};
};

function officeViewReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, islookingupContact: true };
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            const { call_uuid, ...contact } = action.data 
            if (state.currentCall) {
                //Current call but no uuid happens when you add or update a contact during an ongoing call.
                if (!!call_uuid) {
                    const idx = state.calls[call_uuid].legs.findIndex(l => (l.contact_id === contact.contact_id || l.account_id===contact.account_id))
                    if (idx !== -1) {
                        const {channel_uuid, phone} = state.calls[call_uuid].legs[idx]
                        state.calls[call_uuid].legs[idx] = {channel_uuid, phone, ...contact}
                    } 
                    if (state.currentCall === call_uuid) {
                        state.contact_lookup = action.data
                    }
                } else {
                    state.contact_lookup = action.data
                }
            } else if (! state.currentCall) {
                state.contact_lookup = action.data
            }
            return { ...state, islookingupContact: false };
        case getNamedAction(ACTION_NAMES.CONTACT_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, islookingupContact: false };

        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, islookingupUser: true };
        
        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_SUCCESS):
            const { id, username } = action.data[0];
            state.contact_lookup = { name: username, user_id: id }
            return { ...state, islookingupUser: false };
        case getNamedAction(ACTION_NAMES.USER_VIEW_LOOKUP, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, islookingupUser: false };

        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingOfficeView: true };
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_SUCCESS):
            return {
                ...state,
                isReadingOfficeView: false,
                numberOfConferenceRooms: action.data.conference_rooms,
                departments: action.data.departments,
                extensions: action.data.extensions,
                queues: action.data.queues
            };
        case getNamedAction(ACTION_NAMES.OFFICE_VIEW, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingOfficeView: false };

        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCalls: true };
        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCalls: false, calls: action.data };
        case getNamedAction(ACTION_NAMES.CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCalls: false };

        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingRecentCalls: true };
        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingRecentCalls: false, recentCalls: action.data };
        case getNamedAction(ACTION_NAMES.RECENT_CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingRecentCalls: false };
        case getNamedAction(ACTION_NAMES.ACTIVE_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            if (!(action.data.now > 0)) {
                action.data.now = Date.now()/ 1000;
            }
            const drift = parseInt(action.data.now - (Date.now()/ 1000))
            Object.values(action.data.calls).forEach(call => {
                if(call.status === "ringing"){
                    call.display = true;
                }
                call.drift = drift;
                call.actionButtons = {
                    hangup: false,
                    vmDrop: false,
                    transfer: false,
                    hold: false,
                    mute: false,
                    answer: false,
                };
            });
            const currentCallUUID = state.currentCall || action?.data?.extensions[state.creds.extension]?.[0]
            const userCall = (action.data?.extensions && action.data?.extensions[state.creds?.extension]?.length) ?
                action.data?.calls[currentCallUUID] : null; 
            let leg = userCall?.legs?.find(l => l?.extension !== state?.creds?.extension);
            if (! leg && userCall?.company_destination) {
                leg = { name: userCall.destination_name, extension: userCall.company_destination }
            }
            return {
                ...state,
                extensions: action.data?.extensions || {},
                calls: action.data?.calls || {},
                ...(userCall ? {
                    callState: userCall.status,
                    currentCall: userCall.uuid,
                    callDirection: userCall.direction,
                    contact_lookup: leg,
                    currentCallPhoneNumber: leg.phone || leg.extension
            }: {}) };
        case types.ASSIGN_INCOMING_CALL_TO_QUEUE:
            return {
                ...state,
                queues: action.queues,
                incomingCalls: action.incomingCalls
            }
        case types.ASSIGN_INCOMING_CALL_TO_DEPARTMENT_AGENT:
            return {
                ...state,
                extensions: action.extensions,
                incomingCalls: action.incomingCalls
            }
        case types.ASSIGN_QUEUED_CALL_TO_DEPARTMENT_AGENT:
            return {
                ...state,
                extensions: action.extensions,
                queues: action.queues
            }

        case types.CALL_REQUEST:
            return { ...state, isCalling: true }
        case types.CALL_SUCCESS:
            return {
                ...state,
                incomingCalls: action.incomingCalls,
                callerInActionsView: action.contact || {},
                isActiveCall: true,
                actionsViewVisible: true,
                isCalling: true
            };
        case types.CALL_FAILURE:
            return { ...state, isCalling: false }

        case types.CLICK_RECENT_CALL:
            return {
                ...state,
                callerInActionsView: action.contact,
                actionsViewVisible: true,
                isActiveCall: false
            }

        case types.CLOSE_ACTIONS_VIEW:
            return { ...state, actionsViewVisible: false }

        case types.CLICK_ACTIVE_CALLER:
            return {
                ...state,
                callerInActionsView: action.contact,
                isActiveCall: true,
                actionsViewVisible: true
            }

        case types.REORDER_CALL_QUEUES:
            return {
                ...state,
                queues: action.queues
            }

        case types.HANGUP:
            return {
                ...state,
                isActiveCall: false,
                actionsViewVisible: false,
                callerInActionsView: null
            }
        case types.CHANGE_TEAMS_TAB:
            return {
                ...state,
                selectedTeamsTab: action.teamsTab
            }
        case callTypes.QUEUE:
            //only for parking lots & conference rooms
            const current = Math.floor((new Date()).getTime() / 1000)
            action.call.start = current
            if (action.call.company_destination.substr(0,4) === 'park' || action.call.company_destination.substr(0,1) === '7') {
                action.call.connected = current
            } 
            //Adds to company destinations
            const userLeg = action.call.legs.find(l => (l.user_id)); 

            if (state.extensions[action.call.company_destination]) {
                state.extensions[action.call.company_destination].push(action.call.uuid)
                if (action.call.company_destination.substr(0,1) === '7') {
                    //Add to Team View
                    if(userLeg){
                        if (state.extensions[userLeg.extension]) {
                            state.extensions[userLeg.extension].push(action.call.uuid)
                        } else {
                            state.extensions[userLeg.extension] = [action.call.uuid]
                        }
                    } 
                } 
            } else {
                if (state.extensions[action.call.company_destination]) {
                    state.extensions[action.call.company_destination].push(action.call.uuid)
                } else {
                    state.extensions[action.call.company_destination] = [action.call.uuid]
                }
                //Add to Team View
                if(userLeg){
                    if (state.extensions[userLeg.extension]) {
                        state.extensions[userLeg.extension].push(action.call.uuid)
                    } else {
                        state.extensions[userLeg.extension] = [action.call.uuid]
                    }
                } 
            }

            let currentCall;
            if (!state.calls[action.call.uuid]) {
                currentCall = { 
                    ...action.call,
                    ...({
                        //dialing into a conference room
                        actionButtons: {
                            hangup: false,
                            vmDrop: false,
                            transfer: false,
                            hold: false,
                            mute: false,
                            answer: false,
                        },
                        status: "active"
                    }),    
                }
            } else {
                currentCall = {
                    ...state.calls[action.call.uuid], 
                    start: action.call.start, 
                    connected: action.call.connected, 
                    company_destination: action.call.company_destination,           
                }
            }

            if (action.call.company_destination.substr(0,1) === "7" && action.call.direction === "internal" && state.creds.extension && action.call.legs.find(l => l.extension === state.creds.extension)) {
                //dialing into a conference room
                state.currentCall = action.call.uuid
                state.callState = "active"
                state.contact_lookup = { name: action.call.destination_name } //, user_id: id 
                state.callDirection = action.call.direction
                state.currentCallPhoneNumber = action.call.company_destination
            }

            state.calls[action.call.uuid] = currentCall
            return { ...state, extensions: {...state.extensions}, calls: { ...state.calls } }
        case callTypes.QUEUE_END:
            state.extensions[action.call.company_destination] = state.extensions[action.call.company_destination]?.filter(uuid => uuid !== action.call.uuid)
            return {...state, extensions: {...state.extensions}, calls: { ...state.calls } }
        case callTypes.NEW_CALL:
            return newCall({ ...state }, action.leg, action.call)
        case callTypes.END_CALL:
            return endCall({ ...state }, action.leg, action.call)
        case callTypes.CONNECT_CALL:
            return connectedCall({ ...state }, action.leg, action.call)

        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCreds: true };
        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCreds: false, creds: (action.data?.extension || action.data?.lead_connect) ? action.data : {}};
        case getNamedAction(ACTION_NAMES.SOFTPHONE_CREDS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCreds: false, creds: {} };

        case 'RINGING_CALL':
            return { ...state, callState: 'ringing' };
        case 'ACTIVE_CALL':
            return { ...state, callState: 'active' };
        case 'IDLE_CALL':
            return { ...state, callState: 'idle' };
        case 'HANGUP_CALL':
            return { ...state, callState: 'hangup', currentCall: null, callDirection: null };
        case 'IGNORE_CALL':
            return { ...state, callState: 'idle', currentCall: null, callDirection: null };
        case 'CALL_DIRECTION':
            return { ...state, callDirection: action.direction };
        case 'CURRENT_CALL':
            return { ...state, currentCall: action.uuid, callState: state.calls[action.uuid]?.status };
        case 'CONTACT_LOOKUP':
            let lookup;
            if(state.calls[action.uuid]?.company_destination?.substr(0,1) === "7"){
                //conference room
                lookup = { name: state.calls[action.uuid].destination_name }
            } else {
                //will find contact/account/user for call
                lookup = PhoneUtil.contactLeg(state.calls[action.uuid], state.creds.extension)
            }
            return { ...state, contact_lookup: lookup };
        case 'CALL_DURATION':
            return { ...state, duration: action.duration };
        case 'CALL_ACTION_BUTTONS':
            if(action.call && state.calls[action.call]){
                state.calls[action.call].actionButtons = { ...state.calls[action.call].actionButtons, ...action.actionButton }
            }
            return { ...state, calls: { ...state.calls }};
        case 'CALL_RECORDING':
            const recordings = action.callRecordings;
            for (const key in recordings) {
                if (state.calls.hasOwnProperty(recordings[key].call_uuid)) {
                    state.calls[recordings[key].call_uuid].callRecording = recordings[key]
                }
                Object.keys(state.endedCalls).forEach(ext => {
                    if (state.endedCalls[ext]?.uuid === recordings[key].call_uuid) {
                        state.endedCalls[ext].callRecording = recordings[key];
                    }
                })
            }  
            return { ...state, calls: { ...state.calls }, endedCalls: {...state.endedCalls}};
        case 'CALL_CURRENT_NUMBER':
            return { ...state, currentCallPhoneNumber: action.currentCallPhoneNumber };
        case 'CALL_CURRENT_TICKER':
            return { ...state, currentCallTicker: action.reset ? 0 : Math.floor((new Date()).getTime() / 1000) };
        case 'SET_SELECTED_TAB':                            
            return { ...state, selectedTab: action.selectedTab };
        case 'CHANGE_RESULT':
            return { ...state, calls: {...state.calls, [action.call]: {...state.calls[action.call], user_result: action.result}} };
        case 'CHANGE_NOTES':
            return { ...state, calls: {...state.calls, [action.call]: {...state.calls[action.call], notes: action.notes}} };
        case 'REMOVE_ENDED_CALL':
            state.endedCalls[action.extension] = null
            return { ...state  };
        case 'CLOSE_CALL_NOTIFICATIONS': 
            const userPhoneCreds = state.creds.extension;
            const calls = state.calls;
            if(action.call && state.calls[action.call]){
                state.calls[action.call].display = false;
            } else if(Object.keys(state.extensions).length !== 0) {
                state.extensions[userPhoneCreds]?.forEach(uuid => {
                    if (calls.hasOwnProperty(uuid)) {
                        state.calls[uuid].display = false;
                    }
                })
            }
            return { ...state, calls: { ...state.calls }}

        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isHangingUp: true };
        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isHangingUp: false };
        case getNamedAction(ACTION_NAMES.HANGUP, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isHangingUp: false };

        case "REMOVE_VIEW_LOOKUP":
            return { ...state, islookingupContact: false, contact_lookup: null, currentCall: null };
        case "CONTACT_MERGE":
            /*
                action.calls is an object with the following structure:
                { [call_uuid]:[channel_uuid] }
            */
            for (const call_uuid in action.calls) {
                const channel_uuid = action.calls[call_uuid];

                if (call_uuid === state.currentCall) {
                    state.contact_lookup = action.contact
                }
                if (state.calls[call_uuid]) {
                    const idx = state.calls[call_uuid].legs.findIndex(l => l.channel_uuid === channel_uuid)
                    state.calls[call_uuid].legs[idx] = {
                        ...state.calls[call_uuid].legs[idx],
                        ...action.contact
                    }
                }
            }
            return {...state};
        default:
            return state;
    }
}


export default officeViewReducer;
